import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgCircleGap = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: "24px",
	viewBox: "0 0 24 24",
	width: "24px",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M12 3A9 9 0 1 1 6.21 5.11",
		fill: "none",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})
});
export default SvgCircleGap;
